import React from 'react';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING, Label } from 'commons-ui';

export const COL_NAMES = {
	_id: '_id',
	gameName: 'gameName',
	createdBy: 'createdBy',
	createdAt: 'createdAt',
	approvedBy: 'approvedBy',
	approvedAt: 'approvedAt',
	status: 'status',
	label: 'label',
	modifiedBy: 'modifiedBy',
	modifiedAt: 'modifiedAt',
	queryText: 'queryText',
	defaultQueryParams: 'defaultQueryParams',
	errorMessage: 'errorMessage',
	rejectedBy: 'rejectedBy',
	rejectedAt: 'rejectedAt'
};

export const AthenaCrudRequestStatus: { [key: number]: string } = {
	0: 'IN_PROGRESS',
	1: 'WAITING_FOR_APPROVAL',
	2: 'APPROVED',
	3: 'REJECTED',
	4: 'FAILED'
};

export const AthenaCrudRequestListConfig = () => {
	return [
		StringColumn({
			title: 'Game Name',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.gameName] || EMPTY_STRING
		}),
		StringColumn({
			title: 'Label',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.label] || EMPTY_STRING
		}),

		StringColumn({
			title: 'Status',
			maxWidth: 300,
			mapDataToValue: (data: any) => {
				const status = data[COL_NAMES.status];
				return AthenaCrudRequestStatus[status] || 'Unknown Status';
			}
		}),
		CustomColumn({
			title: 'Message',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => {
				return { data: data[COL_NAMES.errorMessage] || EMPTY_STRING };
			},
			renderCell: (params: any) => {
				const { value } = params;
				const truncatedDesc = value.data.split(' ').slice(0, 5).join(' ') + (value.data.split(' ').length > 5 ? '...' : '');
				return (
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-start',
							alignItems: 'center',
							width: '100%',
							height: '100%',
							textAlign: 'left'
						}}>
						<Label label={truncatedDesc} toolTip={value.data} />
					</div>
				);
			}
		}),
		StringColumn({
			title: 'Query Text',
			minWidth: 300,
			maxWidth: 500,
			mapDataToValue: (data: any) => data[COL_NAMES.queryText] || EMPTY_STRING
		}),
		StringColumn({
			title: 'defaultQueryParams',
			minWidth: 300,
			maxWidth: 500,
			mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.defaultQueryParams]) || EMPTY_STRING
		}),
		StringColumn({
			title: 'Created By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Created At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.createdAt
		}),
		StringColumn({
			title: 'Updated By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.modifiedBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Updated At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.modifiedAt
		}),
		StringColumn({
			title: 'Approved By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.approvedBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Approved At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.approvedAt || COL_NAMES.rejectedAt
		}),
		StringColumn({
			title: 'Rejected By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.rejectedBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Rejected At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.rejectedAt
		})
	];
};

export const DEFAULT_CONFIG: {
	pageDetails: {
		pageNo: number;
		pageSize: number;
	};
} = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
